import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=7f86e7da&scoped=true&"
import script from "./NewsDetail.vue?vue&type=script&lang=js&"
export * from "./NewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=7f86e7da&scoped=true&lang=css&"
import style1 from "./NewsDetail.vue?vue&type=style&index=1&id=7f86e7da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f86e7da",
  null
  
)

export default component.exports